import { App, DeveloperAppReview, NormalizedServerFeature } from '../models/app';
import { EntityState } from '@reduxjs/toolkit';
import { getAccountFromStorage } from '../utils/sessionStorage';
import { FALLBACK_RATINGS_VISIBILITY_THREASHOLD } from '../utils/constants';

export const appHasRatingsAndReviewsPermission = (ratingsAndReviewsFeatureData: NormalizedServerFeature, appId: Uuid = '', developerId: Uuid = ''): boolean => {
  return ratingsAndReviewsFeatureData.enabled && !ratingsAndReviewsFeatureData.blacklistedApps[appId] && !ratingsAndReviewsFeatureData.blacklistedDevelopers[developerId];
}

export const hasMinReviewsToDisplayAggregateRating = (ratingsAndReviewsFeatureData: NormalizedServerFeature, reviewCount: number = 0): boolean => {
  let {visibilityThreshold} = ratingsAndReviewsFeatureData;
  visibilityThreshold = typeof visibilityThreshold === 'number'? visibilityThreshold : FALLBACK_RATINGS_VISIBILITY_THREASHOLD
  return reviewCount >= visibilityThreshold;
}

export const canShowStarRating = (appId: Uuid, developerId: Uuid, reviewCount: number, ratingsAndReviewsFeatureData: NormalizedServerFeature): boolean => {
  return appHasRatingsAndReviewsPermission(ratingsAndReviewsFeatureData, appId, developerId) && hasMinReviewsToDisplayAggregateRating(ratingsAndReviewsFeatureData, reviewCount);
}

export const hasCreatedReviewAlready = (appReviews: Maybe<EntityState<DeveloperAppReview>>): boolean => {
  let hasCreatedReview = false;
  if (appReviews?.ids.length) {
    const firstReviewId = appReviews.ids[0],
      firstReview = appReviews.entities[firstReviewId];
    if (firstReview?.author.isSelf) hasCreatedReview = true;
  }
  return hasCreatedReview;
}

export const canCreateNewReview = (app: Maybe<App>, appReviews: Maybe<EntityState<DeveloperAppReview>>, installUninstallPermission: boolean): boolean => {
  const account = getAccountFromStorage();
  const hasNoPrimaryDeveloper = !account?.primaryDeveloper;
  const isNonDemo = !!account?.primaryMerchant?.gateway?.production;
  
  return !!app && !!app.installed && installUninstallPermission && hasNoPrimaryDeveloper && !!isNonDemo && !hasCreatedReviewAlready(appReviews);
}
